// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
import { SkinConfig } from './environment-config.model';


//https://data.createpoker.app/app/registration/config/registration1.createpoker.app.json
/* tslint:disable */
export const environment: any = {
  production: false,
  domainname: 'dev2.createpoker.app',
  //  domainname: 'instantplay.cantobyte.io',
  // domainname: 'instantplay.rivercard.vip',
  // domainname: 'instantplay.loco.poker',
  // domainname: 'instantplay.8dragons.live',
  // domainname: 'instantplay.phoenixprovider.com',
  // domainname: 'instantplay.oshipoker.com',
  dataSource: 'https://data.createpoker.app/app/game',

  settings: {}
  // wsUri: 'wss://testgame.theonlypoker.com:14445',
  // httpUrl: 'https://testgame.theonlypoker.com',
  // brand: 'ryops', // done
  // skinName: 'TheOnlyPoker',
  // title: 'Ryops',
  // "themes": [
  //     {
  //         "name": "halloween",
  //         "displayName": "halloween",
  //         "sound": {
  //             "lobby": true,
  //             "endOfHand": true
  //         },
  //         "tableLogo": true
  //     },
  //     {
  //         "name": "neon",
  //         "displayName": "neon",
  //         "sound": {
  //             "lobby": false,
  //             "endOfHand": false
  //         },
  //         "tableLogo": true
  //     },
  //     {
  //         "name": "football",
  //         "displayName": "football",
  //         "sound": {
  //             "lobby": true,
  //             "endOfHand": true
  //         },
  //         "tableLogo": false
  //     },
  //     {
  //         "name": "christmas",
  //         "displayName": "christmas",
  //         "sound": {
  //             "lobby": true,
  //             "endOfHand": true,
  //             "allIn": true,
  //             "betRaise": true,
  //             "bonusUnlock": true,
  //             "call": true,
  //             "click": true,
  //             "fold": true,
  //             "tableOpen": true,
  //             "toggle": true
  //         },
  //         "tableLogo": true
  //     },
  //     {
  //         "name": "ghostKid",
  //         "displayName": "ghost Kid",
  //         "sound": {
  //             "lobby": false,
  //             "endOfHand": false
  //         },
  //         "tableLogo": true
  //     },
  //     {
  //         "name": "starwars",
  //         "displayName": "star wars",
  //         "sound": {
  //             "lobby": false,
  //             "endOfHand": false
  //         },
  //         "tableLogo": false
  //     }
  // ],
  // settings: {
  //     shop: true, // done
  //     emoticonAnimations: true, // done
  //     emoticonTexts: true, // done

  //     cardGlowColor: 0x0002ff, // DONE

  //     playerTimerColor: 0xdf0226, // DONE
  //     playerTimerTimeBankColor: 0x0231df, // DONE
  //     playerTimerBackgroundColor: 0xe3e3e3, // DONE

  //     defaultLanguage: 'en',
  //     languages: [
  //         { value: 'en', displayText: 'English' },
  //         { value: 'ko', displayText: 'Korean' },
  //         { value: 'mn', displayText: 'Mongolian' },
  //         { value: 'vi', displayText: 'Vietnamese' },
  //         { value: 'ir', displayText: 'Persian' },
  //         { value: 'br', displayText: 'Portuguese' },
  //         { value: 'bn', displayText: 'Bengali' },
  //         { value: 'id', displayText: 'Indonesian' },
  //         { value: 'ru', displayText: 'Russian' },
  //         { value: 'de', displayText: 'German' },
  //         { value: 'es', displayText: 'Spanish' },
  //         { value: 'it', displayText: 'Italian' },
  //         { value: 'tr', displayText: 'Turkish' },
  //     ]
  // },
  // "skinSettings": {
  //     "playerCards": [
  //         {
  //             "cardUrl": "assets/common/cards/player/0.png",
  //             "cardJsonUrl": "assets/common/cards/player/0.json"
  //         },
  //         {
  //             "cardUrl": "assets/common/cards/player/6.png",
  //             "cardJsonUrl": "assets/common/cards/player/6.json"
  //         },
  //         {
  //             "cardUrl": "assets/common/cards/player/4.png",
  //             "cardJsonUrl": "assets/common/cards/player/4.json"
  //         }
  //     ],
  //     "tableCards": [
  //         {
  //             "cardUrl": "assets/common/cards/table/0.png",
  //             "cardJsonUrl": "assets/common/cards/table/0.json"
  //         },
  //         {
  //             "cardUrl": "assets/common/cards/table/6.png",
  //             "cardJsonUrl": "assets/common/cards/table/6.json"
  //         },
  //         {
  //             "cardUrl": "assets/common/cards/table/4.png",
  //             "cardJsonUrl": "assets/common/cards/table/4.json"
  //         }
  //     ],
  //     "backCards": [
  //         {
  //             "cardUrl": "assets/brand/ryops/cards/cardBack.png"
  //         },
  //         {
  //             "cardUrl": "assets/brand/ryops/cards/cardBack2.png"
  //         },
  //         {
  //             "cardUrl": "assets/brand/ryops/cards/cardBack3.png"
  //         },
  //         {
  //             "cardUrl": "assets/brand/ryops/cards/cardBack4.png"
  //         }
  //     ],
  //     "tables": {
  //         "landscape": [
  //             {
  //                 "tableUrl": "assets/brand/ryops/tables/table.png"
  //             },
  //             {
  //                 "tableUrl": "assets/brand/ryops/tables/table2.png"
  //             },
  //             {
  //                 "tableUrl": "assets/brand/ryops/tables/table3.png"
  //             },
  //             {
  //                 "tableUrl": "assets/brand/ryops/tables/table4.png"
  //             }
  //         ],
  //         "portrait": [
  //             {
  //                 "tableUrl": "assets/brand/ryops/tables/vertical_table.png"
  //             },
  //             {
  //                 "tableUrl": "assets/brand/ryops/tables/vertical_table2.png"
  //             },
  //             {
  //                 "tableUrl": "assets/brand/ryops/tables/vertical_table3.png"
  //             },
  //             {
  //                 "tableUrl": "assets/brand/ryops/tables/vertical_table4.png"
  //             }
  //         ]
  //     },
  //     "carpets": {
  //         "landscape": [
  //             {
  //                 "carpetType": 1,
  //                 "carpetUrl": "assets/brand/ryops/carpets/background.jpg"
  //             },
  //             {
  //                 "carpetType": 1,
  //                 "carpetUrl": "assets/brand/ryops/carpets/background2.jpg"
  //             },
  //             {
  //                 "carpetType": 1,
  //                 "carpetUrl": "assets/brand/ryops/carpets/background3.jpg"
  //             },
  //             {
  //                 "carpetType": 1,
  //                 "carpetUrl": "assets/brand/ryops/carpets/background4.jpg"
  //             }
  //         ],
  //         "portrait": [
  //             {
  //                 "carpetType": 1,
  //                 "carpetUrl": "assets/brand/ryops/carpets/vertical_background.jpg"
  //             },
  //             {
  //                 "carpetType": 1,
  //                 "carpetUrl": "assets/brand/ryops/carpets/vertical_background2.jpg"
  //             },
  //             {
  //                 "carpetType": 1,
  //                 "carpetUrl": "assets/brand/ryops/carpets/vertical_background3.jpg"
  //             },
  //             {
  //                 "carpetType": 1,
  //                 "carpetUrl": "assets/brand/ryops/carpets/vertical_background4.jpg"
  //             }
  //         ]
  //     },
  // },
  // "lobbyGameTypeFilters": [
  //     {
  //         "realValue": 1,
  //         "displayValue": "Ring Games"
  //     },
  //     {
  //         "realValue": 2,
  //         "displayValue": "Sit'N'Go"
  //     },
  //     {
  //         "realValue": 4,
  //         "displayValue": "Tourney"
  //     },
  //     {
  //         "realValue": 16,
  //         "displayValue": "Spin n Go"
  //     }
  // ],
};
/* tslint:enable */
